import PaginatedTableBalanzaEgresos from '../../components/reportes/balanza/PaginatedTableBalanzaEgresos';
import { Row, Col } from 'antd';
import { withAuthenticationRequired } from "@auth0/auth0-react";
import { useState } from 'react';
import { PageTitle, StatCard, StatCardsContainer } from '../../components/common';
import { theme } from '../../theme';

const EgresoCamiones = () => {  

    const [tableData, setTable] = useState([]);
    const [loading, setLoading] = useState(true);

    const totalFardos = tableData.reduce((sum: number, row: any) => sum + (row.cantidad_fardos || 0), 0);
    const totalKg = tableData.reduce((sum: number, row: any) => sum + ((row.balanza_peso || 0) - (row.kgtara || 0)), 0);
    const promedioKg = Number((totalKg / totalFardos).toFixed(2));

    return (
      <div style={{ padding: '0' }}>
        <PageTitle>Egreso de Camiones</PageTitle>
        <StatCardsContainer gap={16} minColumnWidth="200px">
          <StatCard
            title="Fardos Despachados"
            value={totalFardos}
            color={theme.colors.primary}
            formatNumber
            loading={loading}
          />
          <StatCard
            title="Kg Fibra Despachados"
            value={totalKg}
            color={theme.colors.primary}
            formatNumber
            loading={loading}
          />
          <StatCard
            title="Promedio de Kg por Fardo"
            value={promedioKg}
            color={theme.colors.primary}
            formatNumber
            loading={loading}
          />
        </StatCardsContainer>
        <Row className='my-4'>
          <Col xs={24} md={24} lg={24}>
            <PaginatedTableBalanzaEgresos
              csvName={"reporte_balanza_egresos.xlsx"}
              getTableData={setTable}
              getLoading={setLoading}
            />      
          </Col>
        </Row>
      </div>
    );
};

export default withAuthenticationRequired(EgresoCamiones);
